import { RobotConfusedIcon } from './RobotConfusedIcon';

/**
 * author: Colton Wiscombe
 * id 535C4A09-5555-45A6-8409-BF12E1CDA2DE
 * name robot-confused
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-confused.svg
 * tags
 */
export const EmojiRobotConfusedIcon = RobotConfusedIcon;
export default EmojiRobotConfusedIcon